import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { setTourTripSearchParam, tourSearchRequest } from '../store/slices/tripSearch';

const useTourFilter = (tripId) => {
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const isTripSearch = !tripId;
  const searchObj = useSelector((store) => store.tripSearch.searchObj.tour);
  const filters = useSelector((store) =>
    isTripSearch
      ? store.tripSearch?.searchResult?.filters
      : store.tour?.tourSearches?.[tripId]?.responses?.filters,
  );

  const applyFilter = useCallback(
    (filterValue) => {
      dispatch(setTourTripSearchParam({ ...filterValue, page: 1 }));
      dispatch(tourSearchRequest({ isTripSearch, tripId }));
      track('tourFilterBar.applyFilter', { filter: JSON.stringify(filterValue) });
    },
    [dispatch, track, isTripSearch, tripId],
  );

  return { searchObj, filters, applyFilter };
};

export default useTourFilter;
